/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

module.exports = checkGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-relay/~/lodash/_checkGlobal.js
 ** module id = 612
 ** module chunks = 0
 **/